export const allTrue = {
    home:true,
    load:true,
    cassette:true,
    cassettes:true,
    checkout:true,
    unassign:true,
    patient:true,
    report:true,
    email:true,
    labelhistory:true,
    hubWize:true,
    Covid:true,
    'Covid Assessment Result':true,
    'Staff Screening':true,
    setting:true,
    team:true,
    questionconsent:true,
    consent:true,
    question:true,
    patientResolutionSetting:true,
    staffResolutionSetting:true,
    screeningEmailSetting:true,
    inventory:true,
    label:true,
    support:true,
    academy:true,
    'Training Center':true,
    faq:true,
    login:true,
    register:true,
}

export const covidTrue = {
    home:false,
    load:false,
    cassette:false,
    cassettes:false,
    checkout:false,
    unassign:false,
    patient:false,
    report:false,
    email:false,
    labelhistory:false,
    hubWize:false,
    Covid:true,
    'Covid Assessment Result':true,
    'Staff Screening':true,
    setting:true,
    team:true,
    questionconsent:false,
    consent:true,
    question:true,
    patientResolutionSetting:true,
    staffResolutionSetting:true,
    screeningEmailSetting:true,
    inventory:false,
    label:false,
    support:false,
    academy:false,
    'Training Center':false,
    faq:false,
    login:true,
    register:true,
}

export const screening = {
    home:false,
    load:false,
    cassette:false,
    cassettes:false,
    checkout:false,
    unassign:false,
    patient:true,
    report:false,
    email:true,
    labelhistory:false,
    hubWize:false,
    Covid:true,
    'Covid Assessment Result':true,
    'Staff Screening':true,
    setting:true,
    team:true,
    questionconsent:true,
    consent:true,
    question:true,
    patientResolutionSetting:true,
    staffResolutionSetting:true,
    screeningEmailSetting:true,
    inventory:false,
    label:false,
    support:false,
    academy:false,
    'Training Center':false,
    faq:false,
    login:true,
    register:true,
    logout:true,
}

export const resourceCenter = {
    applications:false,
    home:false,
    load:false,
    cassette:false,
    cassettes:false,
    checkout:false,
    unassign:false,
    patient:false,
    report:false,
    email:false,
    labelhistory:false,
    hubWize:false,
    Covid:false,
    'Covid Assessment Result':false,
    'Staff Screening':false,
    setting:true,
    team:true,
    questionconsent:false,
    consent:false,
    question:false,
    patientResolutionSetting:false,
    staffResolutionSetting:false,
    screeningEmailSetting:false,
    inventory:false,
    label:false,
    support:true,
    academy:true,
    'Training Center':false,
    faq:false,
    login:true,
    register:true,
    logout:true,

}
export const idAndUrl = {
    home:['home'],
    load:['load'],
    cassette:['cassette/cassette'],
    cassettes:['cassettes'],
    checkout:['cassette/assign'],
    unassign:['unassign'],
    patient:['patient'],
    report:['report'],
    email:['list'],
    labelhistory:['labelhistory'],
    hubWize:['hubWize'],
    Covid:['Covid'],
    'Covid Assessment Result':['covid'],
    'Staff Screening':['covidstaffresultlist'],
    team:['team'],
    consent:['consent'],
    question:['question'],
    patientResolutionSetting:['patientResolutionSetting'],
    staffResolutionSetting:['staffResolutionSetting'],
    screeningEmailSetting:['screeningEmailSetting'],
    label:['label'],
    academy:['centers'],
    'Training Center':['tcenter'],
    faq:['faq'],
    login:true,
    register:true,
}
